export const mapDistrictIds = (districtIds) => {
    const isArray = Array.isArray(districtIds);
    if (isArray) {
        return districtIds.map(Number);
    }
    if (typeof districtIds === 'string') {
        return [Number(districtIds)];
    }
    return null;
};
